export default {"src":"/_next/static/media/back-icon.1223ada7.svg","height":14,"width":9,"blurWidth":0,"blurHeight":0};